export enum ExportPowerBIReportFileDownloadFormat {
  pptx,
  pdf,
  zip
}
